module.exports = __webpack_public_path__ + "img/banner_1.527a9145.jpg";